import React, { FunctionComponent, useEffect, useState } from "react";
import "./index.scss";
import EmblaCarousel from "../EmblaCarousel";
import { Typography } from "@material-ui/core";
// import StoryHero from "../StoryHero";
import BlogPostCard from "../../pages/blog/components/BlogPostCard"
import { BlogPost } from "../../services/entities/content";
import { loadBlogPosts } from "../../services/content";
import { handleError } from "util/errors";

type SooksessStoriesProps = {
  hasThumbs?: boolean;
  variant?: string | null;
  // blogPost: BlogPost;
  post?: string | null;
};

export const SooksessStories: FunctionComponent<SooksessStoriesProps> = ({
  hasThumbs = true,
  variant,
  post,
  // blog
}) => {
  interface BlogPageState {
    posts: BlogPost[] | null;
    displayedPosts: number;
  }
  const POSTS_PAGE_SIZE = 10;
  const [blogPageState, setBlogPageState] = useState<BlogPageState>({
    posts: null,
    displayedPosts: POSTS_PAGE_SIZE,
  });

  useEffect(() => {
    loadBlogPosts().then(
      (posts) =>
        setBlogPageState({ displayedPosts: POSTS_PAGE_SIZE, posts: posts }),
      (err) => handleError("Failed loading articles", err)
    );
  }, []);

  return (
    <div className="content-mw section--sooksess-stories">
      <Typography variant="h2" className="section-title" component="h2">
        Sookcess Stories
      </Typography>
      {blogPageState.posts && (
        <EmblaCarousel
          loop={true}
          hasThumbs={hasThumbs}
          hasDots={true}
          largeNavArrows={false}
          align={1}
          variant={variant}
        >
          {blogPageState.posts &&
            blogPageState.posts!.map((post, i) => {
              return (
                <div className="slide-wrapper" key={i}>
                  <BlogPostCard key={i} blogPost={post} shortTitle={post.short_title}
                    image={post.heroImage}
                    highlighted={post.highlighted}
                    text={post.blurb}
                    link={post.url} />
                  {/* <StoryHero
                    shortTitle={post.short_title}
                    image={post.heroImage}
                    highlighted={post.highlighted}
                    text={post.blurb}
                    link={post.url}
                    // stats={post.stats}
                  /> */}
                </div>
              );
            })}
        </EmblaCarousel>
      )}
    </div>
  );
};

export default SooksessStories;
